// Shared form options for SalaryCheck components

export const educationLevels = [
  { id: -1, title: "Vælg uddannelsesniveau" },
  { id: 0, title: "Folkeskole" },
  { id: 1, title: "Erhvervsfaglig uddannelse" },
  { id: 3, title: "Gymnasial uddannelse" },
  { id: 6, title: "Kortere videregående uddannelse" },
  { id: 8, title: "Mellemlang videregående uddannelse" },
  { id: 9, title: "Længere videregående uddannelse" },
  { id: 12, title: "Ph.d.-grad" },
];

export const regions = [
  { id: 1, title: "Region Hovedstaden" },
  { id: 2, title: "Region Midtjylland" },
  { id: 3, title: "Region Nordjylland" },
  { id: 4, title: "Region Sjælland" },
  { id: 5, title: "Region Syddanmark" },
];

export const ageRanges = ["Under 25", "25–34", "35–44", "45–54", "55+"];

export const sectors = ["Privat", "Offentlig", "NGO / organisation", "Selvstændig", "Ved ikke"];

export const responsibilities = ["Junior", "Erfaren", "Senior", "Specialist", "Leder med personaleansvar"];

export const situations = [
  { id: 1, title: "Er min løn fair" },
  { id: 2, title: "Lønforhandling" },
  { id: 3, title: "Nyuddannet" },
  { id: 4, title: "Søger nyt job" },
];
